import type { Stepper } from '../../../domain/Stepper'
import type { StepperDTO, StepperDTODirection } from '../../../domain/StepperDTO'
import { ContentModelId } from '../../../../../types/ContentModelId'
import type { ContentPage } from '../../../../content-page/domain/ContentPage'
import type { SkinVariant } from '../../../../../types/SkinVariant'

import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'
import { mapEntryDTOList } from '../../../../../utils/map-entry-dto-list'

export const mapStepperFromApi = (dto: StepperDTO): Stepper | undefined => {
  if (!isNonNullableEntryDTO(dto)) {
    return undefined
  }

  const { backgroundColor, direction, footer, heading, list, title } = dto.fields

  return {
    contentType: ContentModelId.STEPPER,
    direction: direction.toLowerCase() as Lowercase<StepperDTODirection>,
    footer,
    heading,
    list: mapEntryDTOList<ContentPage>(list),
    skinVariant: backgroundColor?.replace('-color', '') as SkinVariant,
    title,
  }
}
